import React, { forwardRef, useImperativeHandle } from 'react'
import classNames from 'classnames'
import './index.less'
import Icon from 'meinian-package/src/component/icon'
import { PLATFORM_VALUE } from 'meinian-package/src/component/enum'
import Platform from './platform'
import Gender from './gender'
import Category from './category'
import Tag from './tag'
import Mark from './mark'
import Sample from './sample'
import User from './user'
import Inspiration from './inspiration'
import Season from './season'
import AreaIns from './areaIns'
import Element from './element'
import Runway from './runway'
import WholesaleMarket from './wholesaleMarket'
import RetailCity from './retailCity'
import UploadType from './uploadType'
import More from './more'
import ShopType from './shopType'
import GenderAndCategory from './genderAndCategory'
import { onChangeGender, onChangePlatformId, getIndustry } from '../util'
import Store from './store'
import StoreStyle from './storeStyle'
import StoreType from './storeType'
import GoodsCategory from './goodsCategory'
import SalesRange from './salesRange'
import SalseFeatures from './salseFeatures'
import Intelligent from './intelligent'
import ExamineUser from './examineUser'

export default {
  Platform,
  Gender,
  Category,
  Tag,
  Mark,
  Sample,
  User,
  Inspiration,
  Season,
  AreaIns,
  Element,
  Runway,
  WholesaleMarket,
  RetailCity,
  UploadType,
  More,
  ShopType,
  Store,
  StoreStyle,
  StoreType,
  GoodsCategory,
  SalesRange,
  SalseFeatures,
  GenderAndCategory,
  Intelligent,
  ExamineUser
}

export const BaseFilter = forwardRef((props, ref) => {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const { value = {}, onChange = () => { }, inspirationId, needMarkTimes, filterProps = {} } = props
  const {
    requiredTag, hiddenNoTag, hiddenPlatform, hiddenDate, hiddenCategory, hiddenUpdateStyle,
    hiddenElement, hiddenUser, hiddenColl, hiddenGender, hiddenMark, useGenderAndCategory = true, hiddenAnnotate,
    hiddenSample,
    hiddenPriceZoneRange,
    hiddenExamineUser
  } = filterProps
  useImperativeHandle(ref, () => ({
    changePlatformId: platformId => changePlatformId(platformId),
  }))
  const changePlatformId = (platformId) => {
    const newParams = onChangePlatformId(value)
    onChange({ ...newParams, platformId })
  }
  const changeGender = (gender) => {
    const newParams = onChangeGender(value)
    onChange({ ...newParams, gender })
  }
  const changeGenderAndCategory = (gender, category) => {
    const newParams = onChangeGender(value)
    onChange({ ...newParams, gender, category })
  }
  return <>
    {!hiddenPlatform ? <Platform value={Number(value.platformId) || undefined} onChange={platformId => changePlatformId(platformId)} /> : null}
    {value.platformId == PLATFORM_VALUE.ITEM
      ? <ShopType value={value.shopType} onChange={shopType => onChange(pre => ({ ...pre, shopType }))} /> : null}
    {!hiddenUser && value.platformId == PLATFORM_VALUE.UPLOAD ? <User
      value={value.uploadUserList}
      onChange={uploadUserList => onChange(pre => ({ ...pre, uploadUserList }))}
      inspirationId={inspirationId}
      placeholder="上传用户"
    /> : null}
    {useGenderAndCategory ? <GenderAndCategory
      gender={value.gender}
      category={value.category}
      onChange={(gender, category) => changeGenderAndCategory(gender, category)}
      shopStatus={value.platformId == PLATFORM_VALUE.ITEM ? 1 : 0}
    />
      : <>{!hiddenGender ? <Gender value={value.gender} onChange={gender => changeGender(gender)} /> : null}
        {!hiddenCategory
          ? <Category
              value={value.category}
              onChange={category => onChange(pre => ({ ...pre, category }))}
              gender={value.gender}
              shopStatus={value.platformId == PLATFORM_VALUE.ITEM ? 1 : 0}
          />
          : null}</>}
    {!hiddenElement && <Element
      value={value.element}
      onChange={element => onChange(pre => ({ ...pre, element }))}
      industry={getIndustry(value.gender)}
      disabled={(value.gender || value.category) && false}
    />}
    {!hiddenMark ? <Mark
      value={value.markStatus}
      otherValue={value.markTimes}
      inspirationId={inspirationId}
      needMarkTimes={needMarkTimes}
      onChange={(markStatus, item) => onChange(pre => ({ ...pre, markStatus, markTimes: item?.markTimes }))}
    /> : null}
    <Sample value={value.clothFlag} onChange={clothFlag => onChange(pre => ({ ...pre, clothFlag }))} />
    {!hiddenUser && value.platformId != PLATFORM_VALUE.UPLOAD
      ? <User value={value.userIdList} onChange={userIdList => onChange(pre => ({ ...pre, userIdList }))} inspirationId={inspirationId} />
      : null}
    {!hiddenColl ? <Inspiration
      value={value.inspirationIdList}
      onChange={inspirationIdList => onChange(pre => ({ ...pre, inspirationIdList }))}
    /> : null}
    <More
      value={value}
      onChange={val => onChange(pre => ({ ...pre, ...val }))}
      inspirationId={inspirationId}
      hiddenAnnotate={hiddenAnnotate}
      hiddenDate={hiddenDate}
      hiddenUpdateStyle={hiddenUpdateStyle}
      requiredTag={requiredTag}
      hiddenNoTag={hiddenNoTag}
      hiddenSample={hiddenSample}
      hiddenPriceZoneRange={hiddenPriceZoneRange}
      hiddenExamineUser={hiddenExamineUser}
    />
  </>
})

export const ClearFilter = (props) => {
  const { className, style, placeholder = '清除筛选', onChange } = props
  return <span className={classNames('meinian-clear-filter', 'clickable', className)} style={style} onClick={onChange}>
    <Icon type="m-qingchushaixuan" />{placeholder}
  </span>
}
